import "./style.css";
import classNames from "classnames";
import Modal from "../modal";

interface ModalTermsAndConditionsProps {
  className?: string;
  isOpen: boolean;
  setIsOpen?: (value: boolean) => void;
}

export default function ModalTermsAndConditions({
  className = "w-10/12",
  isOpen,
  setIsOpen,
}: ModalTermsAndConditionsProps) {
  return (
    <Modal
      className={classNames(
        "modal-terms-and-confitions-container",
      )}
      modalBoxClass={
        "w-11/12 max-w-5xl"
      }
      title="Terms and Conditions"
      titlePosition="center"
      // titleBorder={false}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen && setIsOpen(false)}
    >
      <div className="terms-and-conditions-detail text-left">
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>

        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
        <p className="indent-5 my-3">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Similique accusantium blanditiis consectetur, qui odit deserunt velit officiis numquam nisi dolorum sunt ullam adipisci veniam voluptatibus illo. Nostrum vitae odio nisi.</p>
      </div>
    </Modal>
  );
}